import { gql } from '@apollo/client';

export const PREDICTIVE_SHIFT_REPORT_DOCUMENT = gql`
  query PredictiveShiftReport(
    $tenantId: String
    $startDate: String!
    $endDate: String!
    $includeUnfilledShifts: Boolean
  ) {
    predictiveShiftReport(
      tenantId: $tenantId
      startDate: $startDate
      endDate: $endDate
      includeUnfilledShifts: $includeUnfilledShifts
    ) {
      jobId
      jobTitle
      jobStatus
      jobStartDate
      jobEndDate
      shiftDate
      totalBreakDurationMinutes
      breakNotes
      shiftDurationMinutes
      shiftDurationPayableMinutes
      assignedUserId
      assignedUserName
      classificationLevelId
      classificationLevelName
      classificationId
      classificationName
      classificationGroupId
      classificationGroupName
      candidatePayRateCents
      clientChargeRateCents
      clientName
      clientId
      clockInTime
      clockOutTime
      jobAddress
      daySequenceId
      daySequenceStatus
    }
  }
`;

export const REQUEST_PREDICTIVE_SHIFT_REPORT_EXPORT = gql`
  mutation RequestPredictiveShiftReportExport(
    $tenantId: String
    $startDate: String!
    $endDate: String!
    $includeUnfilledShifts: Boolean
  ) {
    requestPredictiveShiftReportExport(
      tenantId: $tenantId
      startDate: $startDate
      endDate: $endDate
      includeUnfilledShifts: $includeUnfilledShifts
    ) {
      id
      status
    }
  }
`;
